import {useState} from 'react'

import Style from './style'
import StoreTicket from './ui/StoreTicketRecord'

import MainHeader from 'widget/MainHeader'

import useGetStoreManagerDetail from 'entity/store/useGetStoreManagerDetail'
import usePutStoreManagerPassword from 'entity/store/usePutStoreManagerPassword'

import DTStyle from 'shared/style/detailTableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import useRoleCookie from 'shared/model/useRoleCookie'
import DefaultButton from 'shared/ui/DefaultButton'
import ChangePasswordModal from '../FranchiseManagerDetail/ui/ChangePasswordModal'

import {
	ROLE_SUPER_ADMIN,
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
	convertRoleAsName,
} from 'shared/constant/lookup/role'

const StoreManagerDetail = () => {
	const [userRole] = useRoleCookie()
	const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)

	const [storeManagerData, refetchData] = useGetStoreManagerDetail()
	const [changePasswordRequest, isPasswordChanging] =
		usePutStoreManagerPassword(refetchData)

	const storeManagerDataList = [
		{
			label: 'IDX',
			value: storeManagerData?.data?.idx,
		},
		{
			label: '승인 상태',
			value: storeManagerData?.data?.is_approve ? '승인' : '미승인',
		},
		{
			label: '관리자 이름',
			value: storeManagerData?.data?.name || '-',
		},
		{
			label: '관리자 연락처',
			value: storeManagerData?.data?.contact || '-',
		},
		{
			label: 'ID',
			value: storeManagerData?.data?.id || '-',
		},
		{
			label: '비밀번호',
			value: storeManagerData?.data?.password || '-',
		},
		{
			label: '가입 날짜',
			value: timestampCalculator(storeManagerData?.data?.created_at) || '-',
		},
	]

	const storeDataList = [
		{
			label: '매장 이름',
			value: storeManagerData?.data?.store_name || '-',
		},
		{
			label: '매장 주소',
			value: storeManagerData?.data?.store_address || '-',
		},
	]

	const franchiseDataList = [
		{
			label: '가맹점 이름',
			value: storeManagerData?.data?.franchise_name || '-',
		},
		{
			label: '가맹점 연락처',
			value: storeManagerData?.data?.franchise_contact || '-',
		},
		{
			label: '가맹점 주소',
			value: storeManagerData?.data?.franchise_address || '-',
		},
	]

	const franchiseManager = storeManagerData?.data?.franchise_manager
	const franchiseManagerInfoList = franchiseManager
		? [
				{
					label: '이름',
					value: franchiseManager.name || '-',
				},
				{
					label: '연락처',
					value: franchiseManager.contact || '-',
				},
				{
					label: 'ID',
					value: franchiseManager.id || '-',
				},
			]
		: []

	const logoImg = storeManagerData?.data?.franchise_logo_img

	return (
		<Style.Wrapper>
			<MainHeader
				title={`${storeManagerData?.data?.store_name || '-'}의 정보 보기`}
				btnList={[
					{
						label: '비밀번호 변경',
						clickEvent: () => setIsPasswordModalOpen(true),
						deactive: false,
					},
				]}
			/>

			<Style.AreaDiv>
				<Style.AreaHeader>
					<Style.Title>{convertRoleAsName[ROLE_STORE_MANAGER]} 정보</Style.Title>
				</Style.AreaHeader>
				<DTStyle.TableDiv>
					{storeManagerDataList?.map((elem, index) => (
						<DTStyle.TableElement key={index}>
							<h2>{elem?.label}</h2>
							<p>{elem?.value}</p>
						</DTStyle.TableElement>
					))}
				</DTStyle.TableDiv>
			</Style.AreaDiv>

			<Style.AreaDiv>
				<h2>매장 정보</h2>
				<DTStyle.TableDiv>
					{storeDataList?.map((elem, index) => (
						<DTStyle.TableElement key={index}>
							<h2>{elem?.label}</h2>
							<p>{elem?.value}</p>
						</DTStyle.TableElement>
					))}
				</DTStyle.TableDiv>
			</Style.AreaDiv>

			{userRole === ROLE_SUPER_ADMIN && (
				<>
					<Style.AreaDiv>
						<h2>가맹점 정보</h2>
						<DTStyle.TableDiv>
							{franchiseDataList?.map((elem, index) => (
								<DTStyle.TableElement key={index}>
									<h2>{elem?.label}</h2>
									<p>{elem?.value}</p>
								</DTStyle.TableElement>
							))}
						</DTStyle.TableDiv>
					</Style.AreaDiv>

					{logoImg && (
						<Style.AreaDiv>
							<h2>로고 이미지</h2>
							<div>
								<Style.LogoImg src={logoImg} />
							</div>
						</Style.AreaDiv>
					)}

					{franchiseManager && (
						<Style.AreaDiv>
							<h2>가맹점 관리자 정보</h2>
							<DTStyle.TableDiv>
								{franchiseManagerInfoList?.map((elem, index) => (
									<DTStyle.TableElement key={index}>
										<h2>{elem?.label}</h2>
										<p>{elem?.value}</p>
									</DTStyle.TableElement>
								))}
							</DTStyle.TableDiv>
						</Style.AreaDiv>
					)}
				</>
			)}

			<StoreTicket />

			{isPasswordModalOpen && (
				<ChangePasswordModal
					isOpen={isPasswordModalOpen}
					onClose={() => setIsPasswordModalOpen(false)}
					onSubmit={(newPassword) => changePasswordRequest(newPassword)}
					isLoading={isPasswordChanging}
				/>
			)}
		</Style.Wrapper>
	)
}

export default StoreManagerDetail
